const _i18n_warning = {
  email_check : {
    EN: `E-mail(ID) Required.`,
    KO: `E-mail(ID) Required.`,
    JP: `メールアドレス(ID)は必須です`
  },
}

const _i18n_error = {
  new_password_repeat : {
    EN: `Password and password confirmation do not match`,
    KO: `Password and password confirmation do not match`,
    JP: `パスワードと確認用パスワードが一致しません`
  },
  new_password_repeat_2 : {
    EN: `The password verification entered is not the same`,
    KO: `The password verification entered is not the same`,
    JP: `入力された確認用パスワードが同じではありません`
  },
  permission_check: {
    EN: `Owner already exits`,
    KO: `Owner 권한이 이미 존재합니다.`,
    JP: `Owner 権限が既に存在します。`
  }
}

const i18n_toast = {
  _i18n_warning,
  _i18n_error
}

export default i18n_toast